export enum NotificationType {
  GENERAL_ANNOUNCEMENT = 'GENERAL_ANNOUNCEMENT',
  SYSTEM_ALERT = 'SYSTEM_ALERT',
  MAINTENANCE = 'MAINTENANCE',
  PASSWORD_RESET = 'PASSWORD_RESET',
  REMINDER = 'REMINDER',
  WELCOME_MESSAGE = 'WELCOME_MESSAGE'
}
